import * as types from "../constants/actionTypes";

export const thriveInitialState = {
    card: null,
    report: null,
    cardPending: false,
    reportPending: false,
    cardSuccess: false,
    reportSuccess: false,
    wellBeingReport: null,
    wellBeingReportPending: false,
    wellBeingReportSuccess: false,
    wellBeingReportFailure: false,
    error: ""
};

export default function thriveReducer(state = thriveInitialState, action) {
    switch (action.type) {

        case types.THRIVE_GET_CARD_PENDING:
            return { ...state, cardPending: true };
        case types.THRIVE_GET_CARD_SUCCESS:
            return { ...state, card: action.card, cardPending: false, cardSuccess: true, error: null };
        case types.THRIVE_GET_CARD_FAILURE:
            return { ...state, card: null, cardPending: false, cardSuccess: false, error: action.error };

        case types.THRIVE_GET_REPORT_PENDING:
            return { ...state, report: null, reportPending: true };
        case types.THRIVE_GET_REPORT_SUCCESS:
            return { ...state, report: action.report, reportPending: false, reportSuccess: true, reportError: null };
        case types.THRIVE_GET_REPORT_FAILURE:
            return { ...state, report: null, reportPending: false, reportSuccess: false, reportError: action.error };
        case types.GET_WELLBEING_REPORT_PENDING:
            return { ...state, wellBeingReportPending: true };
        case types.GET_WELLBEING_REPORT_SUCCESS:
            return { ...state, wellBeingReport: action.report, wellBeingReportSuccess: true, wellBeingReportFailure: false, wellBeingReportPending: false }
        case types.GET_WELLBEING_REPORT_FAILURE:
            return { ...state, wellBeingReport: null, wellBeingReportSuccess: false, wellBeingReportFailure: true, wellBeingReportPending: false }
        default:
            return { ...state };
    }
}

